<script>
  export let idUnico = 'destaque';
  export let content;

  content = content.replaceAll('Cannabis', '<i>Cannabis</i>');
  content = content.replaceAll('sativa spp', '<i>sativa spp</i>');
</script>

<div class="container">
  <div class="box">
    <p>
      {@html content}
    </p>
  </div>
</div>

<style>
  .box {
    background: linear-gradient(to right, var(--VERDE_CLARO), var(--VERDE));
    border-radius: 0 20px 0 20px;
    padding: 40px 50px;
  }

  p {
    padding: 0;
    margin: 0;
    color: var(--COR_BRANCO);
    font-weight: 700;
  }

  @media (max-width: 767px) {
    .box {
      padding: 40px 30px;
    }
  }
</style>
